import { tokens } from '@sail/ui';
import { setStaticToken } from '@sail/engine';
export const setViewportTokens = ()=>{
    setStaticToken(tokens.viewport.xsmall, '450px');
    setStaticToken(tokens.viewport.small, '600px');
    setStaticToken(tokens.viewport.medium, '750px');
    setStaticToken(tokens.viewport.large, '900px');
    setStaticToken(tokens.viewport.xlarge, '1112px');
};

//# sourceMappingURL=viewport.js.map